import { render, staticRenderFns } from "./contactFieldsEditor.vue?vue&type=template&id=0c56a2fc&scoped=true"
import script from "./contactFieldsEditor.vue?vue&type=script&lang=ts"
export * from "./contactFieldsEditor.vue?vue&type=script&lang=ts"
import style0 from "./contactFieldsEditor.vue?vue&type=style&index=0&id=0c56a2fc&prod&scoped=true&lang=css"
import style1 from "@/components/acquisitionList/ui/acquisitionViews.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./modern.css?vue&type=style&index=2&prod&lang=css&external"
import style3 from "./modernDialog.css?vue&type=style&index=3&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c56a2fc",
  null
  
)

export default component.exports